import { BpAnchor } from '../../../../shared/components/text/anchor/BpAnchor'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../../app/store/hooks/Redux'
import { objectToQuery } from '../../../../shared/lib/helpers/ObjectToQuery'
import {
  initialAdOverviewFilters,
  setAdOverviewFilter,
  setOnlyShoppingAds,
} from '../../../ad-overview/model/adOverviewSlice'
import { IAdOverviewFilter } from '../../../ad-overview/model/types/AdOverviewFilter.interface'
import { IPpcComplianceFilter } from '../../model/types/PpcComplianceFilter.interface'
import { selectPpcComplianceFilter } from '../../model/ppcComplianceSlice'

const REVERSED_TO_AD_OVERVIEW: Record<string, string> = {
  engine_id: 'engine_id',
  browser_id: 'browser_id',
  city_id: 'city_id',
  advertiser_id: 'advertiser_id',
  keyword: 'search',
}

interface AdsCountCellProps {
  id: number
  ads_count: number
  is_only_shopping_ads: boolean
}

export const AdsCountCell = ({ id, ads_count, is_only_shopping_ads }: AdsCountCellProps) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const {
    project,
    country,
    dateRange,
    city,
    browser,
    engine,
    site,
    advertiserName,
    keyword,
    hidden,
    adHijackers,
    shoppingAds,
    reversed_filters,
  } = useAppSelector<IPpcComplianceFilter>(selectPpcComplianceFilter)

  const reversed = reversed_filters ? reversed_filters.split(',') : []
  const filters: IAdOverviewFilter = {
    ...initialAdOverviewFilters,
    affiliate: String(id),
    country,
    dateRange,
    project,
    city,
    browser,
    engine,
    adDomain: reversed.includes('site') ? '' : site,
    advertiserName,
    search: keyword,
    show_hidden: hidden,
    policy: adHijackers ? 'ad_hijacking' : '',
    reversed_filters: reversed.flatMap((key) => REVERSED_TO_AD_OVERVIEW[key] ?? []).join(','),
  }

  return (
    <BpAnchor
      href={`/adv-overview?${objectToQuery({ ...filters })}`}
      onClick={(e) => {
        e.preventDefault()
        navigate('/adv-overview')
        dispatch(setAdOverviewFilter(filters))
        dispatch(setOnlyShoppingAds(shoppingAds || is_only_shopping_ads))
      }}
    >
      {ads_count}
    </BpAnchor>
  )
}
